import React from "react";
import Button from "react-bootstrap/Button";
import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
    icon: LucideIcon;
    title: string;
    message: string;
    actionLabel: string;
    onAction: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, message, actionLabel, onAction }) => (
    <div className="empty-state border rounded-3 p-5 d-flex flex-column align-items-center text-center gap-2">
        <Icon size={40} className="text-body-secondary opacity-50 mb-2" aria-hidden="true" />
        <div className="empty-state-title">{title}</div>
        <p className="small text-body-secondary mb-3">{message}</p>
        <Button variant="primary" onClick={onAction}>
            {actionLabel}
        </Button>
    </div>
);

export default EmptyState;
